"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'dvb';
exports.SET_IS_MW_READY = exports.namespace + "/SET_IS_MW_READY";
exports.SET_MW_CTX_COUNT = exports.namespace + "/SET_MW_CTX_COUNT";
exports.SET_MW_EVENT_SOURCE = exports.namespace + "/SET_MW_EVENT_SOURCE";
exports.SET_SCAN_PARAMS = exports.namespace + "/SET_SCAN_PARAMS";
exports.SET_PLAYER_INSTANCE_ID = exports.namespace + "/SET_PLAYER_INSTANCE_ID";
exports.SET_SCAN_DVB_STATE = exports.namespace + "/SET_SCAN_DVB_STATE";
exports.SET_IS_CAS_HOME_SET = exports.namespace + "/SET_IS_CAS_HOME_SET";
exports.SET_HAS_MAIL = exports.namespace + "/SET_HAS_MAIL";
exports.SET_IS_SERVICE_STATUS_OPEN = exports.namespace + "/SET_IS_SERVICE_STATUS_OPEN";
exports.SET_IS_CAS_MODAL_DISPLAYED = exports.namespace + "/SET_IS_CAS_MODAL_DISPLAYED";
exports.SET_IS_E016_ENTITLEMENT_ERROR = exports.namespace + "/SET_IS_E016_ENTITLEMENT_ERROR";
exports.SET_DVB_RESERVATION_ID = exports.namespace + "/SET_DVB_RESERVATION_ID";
exports.SET_IS_PLAYER_SURFACE_SET = exports.namespace + "/SET_IS_PLAYER_SURFACE_SET";
exports.SET_PLAYER_ACTION_DONE = exports.namespace + "/SET_PLAYER_ACTION_DONE";
exports.SET_QUERY_RECORDINGS_STATE = exports.namespace + "/SET_QUERY_RECORDINGS_STATE";
exports.SET_IS_DVB_SIGAL_OK = exports.namespace + "/SET_IS_DVB_SIGAL_OK";
exports.SET_HAS_SATELLITE_CONNECTION = exports.namespace + "/SET_HAS_SATELLITE_CONNECTION";
exports.AUTO_LNB_DETECTION_STATUS = exports.namespace + "/AUTO_LNB_DETECTION_STATUS";
exports.SET_FORCE_SCAN = exports.namespace + "/SET_FORCE_SCAN";
//# sourceMappingURL=constants.js.map